import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export interface BambooMetaField {
  id: string | null
  name: string | null
  alias: string | null
  type: string | null
  relevant: boolean
}

export interface BambooMetaList {
  name: string | null
  alias: string | null
  options: string[]
  relevant: boolean
}

export interface BambooTimeOffType {
  id: string | null
  name: string | null
}

export interface BambooDistinctValue {
  value: string
  count: number
}

export interface BambooIntrospectResponse {
  subdomain: string
  is_sandbox: boolean
  employees_returned: number
  meta_fields: BambooMetaField[]
  meta_lists: BambooMetaList[]
  time_off_types: BambooTimeOffType[]
  distinct_values: Record<string, BambooDistinctValue[]>
  warnings: string[]
}

/**
 * Fetches BambooHR introspection metadata.
 *
 * This hits the live BambooHR API using the app's configured credentials, so it
 * is manual-trigger only (`enabled: false`) — call `refetch()` from a button.
 * It does not run on mount.
 */
export function useBambooIntrospect() {
  return useQuery({
    queryKey: ['admin', 'bamboo-introspect'],
    queryFn: () => fetchApi<BambooIntrospectResponse>('/api/org/bamboo/introspect'),
    enabled: false,
    gcTime: 0,
    retry: false,
  })
}
